// extracted by mini-css-extract-plugin
export default {"content":"AboutHub_content__51QH-","h2":"AboutHub_h2__ubdFY","text":"AboutHub_text__9z0oC","link":"AboutHub_link__5kOq6"};